import { css } from '@emotion/css';

export const ratingLabelStyles = css`
  min-width: 5.6rem;
  overflow-wrap: anywhere;
`;

export const thumbStyles = css`
  background-color: white;
  border: 3px solid black;
  width: 16px;
  height: 16px;
`;

export const markStyles = css`
  color: white !important;
  height: 6px;
  width: 2px;

  &:nth-child(3) {
    // this is always the first marker
    display: none;
  }
`;

export const sliderStyles = css`
  .MuiSlider-root {
    height: 6px !important;
  }
`;

export const markLabelStyles = css`
  font-size: 12px;
  top: 35px;
`;

export const railStyles = css`
  background-color: var(--gray-400);
`;
